import { useQuery } from "react-query";
import { getAllAgreementsCount } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useAllAgreementCount = () => {
  return useQuery("GetAllAgreementsCount", getAllAgreementsCount, {
    refetchOnWindowFocus: false,
  });
};

export default useAllAgreementCount;
